import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { authServices } from '../authServices'
import { RecoveryCodeDTO, SendRecoveryCodeToEmailPayload } from '../authTypes'

import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useSendRecoveryCodeToEmail = (
  options?: IOptionsUseMutation<RecoveryCodeDTO>,
) => {
  const { t } = useTranslation()

  return useMutation<
    RecoveryCodeDTO,
    ErrorDetail,
    SendRecoveryCodeToEmailPayload
  >({
    mutationFn: authServices.sendRecoveryCodeToEmail,
    onSuccess: (data) => {
      if (options?.onSuccess) {
        options?.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)

      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.ACTION_IS_NOT_ALLOWED) {
        errorMessage = t('api:yourAccountIsDeleted')
      }

      if (code === ApiErrorCode.USER_NOT_FOUND) {
        errorMessage = t('api:emailNotValidOrNotVerified')
      }

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (options?.onError) {
        options?.onError({ ...err, errorMessage: t(errorMessage), code })
      }
    },
  })
}
